<template>
    <div>
        <div class="col-md-12">
            <label style="font-size: 15px">
                <input v-model="is_chosen_all_brands" @change="selectAllBrands()" type="checkbox">
                {{ translations.select_all }}
            </label>
        </div>
        <br>
        <div class="col-md-12" style="height: 400px; overflow-y: scroll;">
            <div class="col-md-12">
                <div class="form-group">
                    <input type="text" class="form-control" v-model="term">
                </div>
            </div>
            <div class="col-md-2" style="height: 44px" v-for="brand in filtered_brands">
                <div class="form-group">
                    <label>
                        <input type="checkbox" name="brands[]" :value="brand.id" v-model="chosen_brands">
                        {{ brand.title }}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['brands', 'translations'],
        data() {
            return {
                term: '',
                chosen_brands: [],
                is_chosen_all_brands: true,
            };
        },
        mounted() {
            this.chosen_brands = this.pluckIds(this.brands);
        },
        computed: {
            filtered_brands() {
                if (this.term.length < 2) {
                    return this.brands;
                }

                let regular = new RegExp('.*(' + this.term +')+.*', 'i');

                return this.brands.filter((brand) => {
                    return regular.test(brand.title.replace(/[^\wа-яё]+/gi, ""));
                });
            }
        },
        methods: {
            selectAllBrands() {
                this.chosen_brands = this.is_chosen_all_brands
                    ? this.pluckIds(this.brands)
                    : [];
            },
            pluckIds(brands) {
                let ids = [];

                brands.map((brand) => {
                    ids.push(brand.id);
                });

                return ids;
            },
        },
        watch: {
            chosen_brands() {
                this.$emit('update-brands', this.chosen_brands);
            }
        }
    };
</script>
